import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { useState } from "react";
import { IPermissionProps } from "../../models/Login";
import { IModel } from "./MassMailSetting";
import { MassMailSendingCountTable } from "./massMailSendingCountSetting/MassMailSendingCountTable";
import { MassMailExperienceSettingTable } from "./massMailExperienceSetting/MassMailExperienceSettingTable";
import { MassMailInhouseCompanySettingTable } from "./massMailInhouseCompanySetting/MassMailInhouseCompanySettingTable";
import { MassMailServerSettingTable } from "./massMailServerSetting/MassMailServerSettingTable";
import { NextMassMailWaitTimeSettingTable } from "./nextMassMailWaitTimeSetting/NextMassMailWaitTimeSettingTable";
import { MassMailRequestServingSettingTable } from "./massMailRequestServingSetting/MassMailRequestServingSettingTable";

interface IProps {
  setModal: (modal: IModel) => void;
  toast: any;
  reload: boolean;
  permissions: IPermissionProps;
}

export const Table = (props: IProps) => {
  const [activeIndex, setActiveIndex] = useState<number | number[]>();

  const openEdit = () => {
    props.setModal({ open: true });
  };
  const handleCollapseAll = () => {
    setActiveIndex([]);
  };

  const handleExpandAll = () => {
    setActiveIndex([0, 1, 2]);
  };

  const leftToolbarTemplate = () => {
    return (
      <>
        <Button label="Expand All" className="p-button-success mr-2 bg-primary" onClick={handleExpandAll} />
        <Button label="Collapse All" className="p-button-success mr-2 bg-primary" onClick={handleCollapseAll} />
      </>
    );
  };

  const rightToolbarTemplate = () => {
    return <Button label="Update" icon="pi pi-pencil" className="p-button-success mr-2 bg-primary" onClick={openEdit} />;
  };

  return (
    <>
      <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
      <Accordion multiple activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        {/* <AccordionTab header="Email Sending Count Setting">
          <MassMailSendingCountTable reload={props.reload} toast={props.toast} />
        </AccordionTab> */}
        {/* <AccordionTab header="Experience Months Count Setting">
          <MassMailExperienceSettingTable reload={props.reload} toast={props.toast} />
        </AccordionTab> */}
        <AccordionTab header="Next Mass Mail  Request Waiting Time Setting">
          <NextMassMailWaitTimeSettingTable reload={props.reload} toast={props.toast} />
        </AccordionTab>
        <AccordionTab header="Company Wise Max Sending Mail  Count Setting">
          <MassMailInhouseCompanySettingTable reload={props.reload} toast={props.toast} />
        </AccordionTab>
        <AccordionTab header="Mass Mail Server Setting">
          <MassMailServerSettingTable reload={props.reload} toast={props.toast} />
        </AccordionTab>
        <AccordionTab header="Next Mass Mail  Request Serving Setting">
          <MassMailRequestServingSettingTable reload={props.reload} toast={props.toast} />
        </AccordionTab>
      </Accordion>
    </>
  );
};
